/**
 * Trạng X1ONline
 */
export default {
  NotPermission: 2, // Không có quyền
  Success: 1, //Thành công
  Fail: 0, //Lỗi
  RuntimeError: -1, //Lỗi Runtime
};
